import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Layout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    function handleLogout() {
        logout();
        navigate('/login');
    }

    return (
        <div className="app-layout">
            {/* Desktop Sidebar */}
            <nav className="sidebar" role="navigation" aria-label="Main navigation">
                <div className="sidebar-header">
                    <div className="logo">
                        <div className="logo-icon">🛡️</div>
                        <div className="logo-text">
                            <span>HSA Tracker</span>
                            <span className="logo-subtitle">Receipt Records</span>
                        </div>
                    </div>
                </div>

                <ul className="nav-links">
                    <li><NavLink to="/payments">Payments</NavLink></li>
                    <li><NavLink to="/reviewed-import">Reviewed Import</NavLink></li>
                    <li>
                        <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>
                            <span className="nav-icon">📊</span>
                            Dashboard
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/upload" className={({ isActive }) => isActive ? 'active' : ''}>
                            <span className="nav-icon">➕</span>
                            Add Receipt
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/expenses" className={({ isActive }) => isActive ? 'active' : ''}>
                            <span className="nav-icon">📋</span>
                            My Expenses
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/eligibility" className={({ isActive }) => isActive ? 'active' : ''}>
                            <span className="nav-icon">✅</span>
                            Eligibility Check
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/export" className={({ isActive }) => isActive ? 'active' : ''}>
                            <span className="nav-icon">📥</span>
                            Export
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/settings" className={({ isActive }) => isActive ? 'active' : ''}>
                            <span className="nav-icon">⚙️</span>
                            Settings
                        </NavLink>
                    </li>
                </ul>

                <div className="sidebar-footer">
                    <div className="user-info">
                        <span className="user-avatar">{user?.name?.charAt(0).toUpperCase()}</span>
                        <span className="user-name">{user?.name}</span>
                    </div>
                    <button onClick={handleLogout} className="logout-btn" aria-label="Log out">
                        🔒 Lock App
                    </button>
                </div>
            </nav>

            {/* Mobile Bottom Navigation */}
            <nav className="mobile-nav" role="navigation" aria-label="Mobile navigation">
                <NavLink to="/" end className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                    <span className="nav-icon">📊</span>
                    Home
                </NavLink>
                <NavLink to="/upload" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                    <span className="nav-icon">➕</span>
                    Add
                </NavLink>
                <NavLink to="/expenses" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                    <span className="nav-icon">📋</span>
                    List
                </NavLink>
                <NavLink to="/eligibility" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                    <span className="nav-icon">✅</span>
                    Check
                </NavLink>
                <NavLink to="/export" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                    <span className="nav-icon">📥</span>
                    Export
                </NavLink>
                <NavLink to="/settings" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                    <span className="nav-icon">⚙️</span>
                    Settings
                </NavLink>
            </nav>

            <main className="main-content" role="main">
                <Outlet />
            </main>
        </div>
    );
}
